import axios from "axios";
import moment from "moment"

export default {
    data(){
        return {
            backendExpertIndex: 'backend.expert.index',
            backendExpertView: 'backend.expert.view',
        }
    },
    methods: {
        formatDate(date) {
            return moment(date).format('DD MMM Y')
        },
        getCleanPhone(prefix, phone) {
            const result = parseInt(phone);

            return `${prefix}${result}`;
          },
        isJobBlacklisted(job, project) {
            if (!project || !project.project_dnc_companies) return false;
            const companyName = (job.company_name?.company_name || "").toLowerCase();
            if (!companyName) return false;
            return project.project_dnc_companies.some((company) => {
                const companyPrefix = job.job_prefix === "Former" ? "Former" : "Current";
                const dncCompanyName = (company.company_name || "").toLowerCase();
                const nameMatch = companyName.includes(dncCompanyName) || dncCompanyName.includes(companyName);
                return nameMatch && company.type === companyPrefix;
            });
        },
        async getMyUser(){
            const response = await axios.get('/admin/me')
            return response.data
        },
        async getPermittedRoutes() {
            const response = await axios.get("/admin/permitted-routes");
            return response.data;
          },
        async getSingleWpMessage(str) {
            const response = await axios.post("/admin/get-translation", {
              translation: str,
            });
             return response.data;
          },
        async checkExpertUnsubscribeStatus(expertId) {
            try {
                const url = `/api/v1/expert/fetch-unsubscribe-status?expert_id=${expertId}`;
                const response = await axios.get(url);
                // Assumes the API returns { has_unsubscribed: true/false }
                return Boolean(response.data && response.data.data.is_unsubscribed);
            } catch (error) {
                return false;
            }
        },
        async fetchBulkExpertUnsubscribeStatus(expertIds) {
            try {
                const response = await axios.post(
                    '/api/v1/expert/bulk-unsubscribe-status',
                    { expert_ids: expertIds }
                );
                return (response.data && response.data.data && response.data.data.unsubscribed_expert_ids) || [];
            } catch (error) {
                return [];
            }
        }
    }
}
